// src/services/analytics.js
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';
import app from '../config/firebase';

let initPromise = null;

// Lazily resolves the Analytics instance. Resolves to null (events become
// no-ops) if the environment doesn't support Analytics or measurementId
// isn't configured yet — see config/firebase.js.
function getInstance() {
  if (!initPromise) {
    initPromise = isSupported()
      .then((supported) => {
        if (!supported) {
          console.warn('[analytics] Not supported in this environment — events are no-ops.');
          return null;
        }
        if (!process.env.REACT_APP_FIREBASE_MEASUREMENT_ID) {
          console.warn('[analytics] REACT_APP_FIREBASE_MEASUREMENT_ID is not set — events are no-ops.');
          return null;
        }
        return getAnalytics(app);
      })
      .catch((err) => {
        console.warn('[analytics] Failed to initialize:', err.message);
        return null;
      });
  }
  return initPromise;
}

function track(eventName, params = {}) {
  getInstance().then((instance) => {
    if (!instance) return;
    logEvent(instance, eventName, params);
  });
}

export function trackSignupCompleted({ method }) {
  track('signup_completed', { method });
}

export function trackOpportunityViewed({ opportunityId, category }) {
  track('opportunity_viewed', { opportunity_id: opportunityId, category });
}

export function trackOpportunitySaved({ opportunityId, category, saved }) {
  track('opportunity_saved', { opportunity_id: opportunityId, category, saved });
}

export function trackOpportunityApplied({ opportunityId, category }) {
  track('opportunity_applied', { opportunity_id: opportunityId, category });
}

export function trackUpgradeClicked({ plan }) {
  track('upgrade_clicked', { plan });
}

export function trackUpgradeCompleted({ plan }) {
  track('upgrade_completed', { plan });
}

export function trackGuestActionBlocked({ action }) {
  track('guest_action_blocked', { action });
}
